import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconPremiumPartner = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M22.6,16.3c-1.3-1.6-3-2.7-5-3.3l0,0c-1.7-0.5-3.3-0.5-5-0.1l0,0c-1.9,0.5-3.6,1.5-4.9,3c-1.5,1.8-2.4,4-2.4,6.3l0,1.6
		c0,2.9,0,4.5,0,4.6l0.1,0.7h7h5.4h6.8l0.1-0.7c0-0.1,0-0.2,0-4.6l0-1.6C24.7,20.2,24,18.1,22.6,16.3z M23.1,24c0,2,0,3.1,0,3.8
		h-5.3h-5.4H6.9c0-0.8,0-2.1,0-3.8l0-1.6c0-2,0.7-3.8,2-5.3c1.1-1.2,2.5-2.1,4.1-2.5h0c1.4-0.4,2.8-0.4,4.2,0h0
		c1.7,0.5,3.1,1.4,4.2,2.8c1.2,1.5,1.8,3.2,1.8,5.1L23.1,24z"/>
        <path d="M15,11.2c2.9,0,5.3-2.4,5.3-5.3S17.9,0.7,15,0.7S9.7,3.1,9.7,6S12.1,11.2,15,11.2z M15,2.3c2,0,3.7,1.7,3.7,3.7
		S17,9.6,15,9.6S11.3,8,11.3,6S13,2.3,15,2.3z"/>
      </g>
    </SvgIcon>
  );
};
// IconPremiumPartner = pure(IconPremiumPartner);
IconPremiumPartner.displayName = 'IconPremiumPartner';
IconPremiumPartner.muiName = 'SvgIcon';

export default IconPremiumPartner;



// WEBPACK FOOTER //
// ./src/components/Icons/IconPremiumPartner.js